import request from "./request";

export function getLogHistoryAPI(params: any) {
    return request(`/api/UserLogs?${new URLSearchParams(params)}`, { method: 'GET' });
}

export function getUserLogsEventsAPI() {
    return request(`/api/UserLogs/events`, { method: 'GET' });
}
